/**
 * French Dashboard Content - UI strings for French dashboard at /fr/dashboard
 * This file contains all translatable strings for the dashboard interface.
 */
window.FrenchDashboardContent = {
    // ==========================================
    // HEADER & NAVIGATION
    // ==========================================
    header: {
        dashboard: "Tableau de Bord",
        responses: "Réponses",
        myForms: "Mes Formulaires",
        signOut: "Déconnexion",
        upgrade: "Mettre à niveau",
        free: "Gratuit",
        basic: "Événement Pro",
        premium: "Signature",
        viewOnly: "Lecture Seule"
    },

    // ==========================================
    // TAB NAVIGATION
    // ==========================================
    tabs: {
        responses: "Réponses",
        analytics: "Statistiques",
        campaigns: "Messages aux Invités",
        export: "Exporter"
    },

    // ==========================================
    // RESPONSES TAB
    // ==========================================
    responses: {
        title: "Réponses",
        totalResponses: "Total des Réponses",
        attending: "Présents",
        notAttending: "Absents",
        maybe: "Peut-être",
        adults: "Adultes",
        children: "Enfants",
        searchPlaceholder: "Rechercher par nom, email ou téléphone...",
        filterAll: "Toutes les Réponses",
        filterYes: "Oui - Présents",
        filterNo: "Non - Absents",
        filterMaybe: "Peut-être",
        noResponses: "Aucune réponse pour le moment",
        noResponsesDesc: "Les réponses apparaîtront ici lorsque les invités confirmeront leur présence.",
        shareFirstDesc: "Partagez le lien avec vos invités. Leurs réponses s'afficheront ici.",
        sendInvitations: "Envoyer les invitations",
        copyLink: "Copier le lien",
        generalLink: "Lien général",
        personalLinks: "Liens personnels",
        loading: "Chargement des réponses...",
        deleteConfirm: "Êtes-vous sûr de vouloir supprimer cette réponse ?",
        deleteSuccess: "Réponse supprimée avec succès",
        saveSuccess: "Modifications enregistrées avec succès",
        saveError: "Erreur lors de l'enregistrement des modifications"
    },

    // ==========================================
    // TABLE HEADERS
    // ==========================================
    table: {
        name: "Nom",
        email: "Email",
        phone: "Téléphone",
        attending: "Présence",
        guestCount: "Invités",
        dietary: "Régime",
        relationship: "Relation",
        message: "Message",
        submittedAt: "Date d'envoi",
        actions: "Actions",
        yes: "Oui",
        no: "Non",
        maybe: "Peut-être"
    },

    // ==========================================
    // ANALYTICS TAB
    // ==========================================
    analytics: {
        title: "Statistiques de l'Événement",
        responseRate: "Taux de Réponse",
        totalInvited: "Total Invités",
        totalResponded: "Total Répondus",
        pending: "En Attente",
        attendanceBreakdown: "Répartition des Présences",
        guestBreakdown: "Répartition des Invités",
        responseTimeline: "Chronologie des Réponses",
        dietaryPreferences: "Préférences Alimentaires",
        relationships: "Relations",
        setupTracking: "Configurer le Suivi",
        setupTrackingDesc: "Entrez le nombre d'invitations envoyées pour voir les statistiques du taux de réponse.",
        invitationsSent: "Invitations Envoyées",
        manualCount: "Comptage Manuel",
        autoDetection: "Détection Automatique",
        switchToAuto: "Passer à la détection automatique ?",
        noAnalyticsYet: "Aucune statistique disponible pour le moment",
        noAnalyticsDesc: "Les statistiques apparaîtront lorsque vous recevrez des réponses."
    },

    // ==========================================
    // CAMPAIGNS TAB
    // ==========================================
    campaigns: {
        title: "Messages aux Invités",
        newCampaign: "Envoyer des messages",
        sendInvitations: "Envoyer des Invitations",
        campaignHistory: "Historique des Messages",
        noCampaigns: "Prêt à inviter vos invités ?",
        noCampaignsDesc: "Envoyez des invitations personnalisées par email ou WhatsApp. Nous suivrons qui ouvre et répond.",
        createFirst: "Envoyer des Invitations",
        contactStatus: "Statut des Contacts",
        sendReminder: "Envoyer un Rappel",
        scheduledReminders: "Rappels Programmés",
        credits: "Crédits",
        buyCredits: "Acheter des Crédits",
        messagesSent: "messages envoyés",
        delivered: "livrés",
        opened: "ouverts",
        clicked: "cliqués",
        responded: "ont répondu",
        pending: "en attente"
    },

    // ==========================================
    // CAMPAIGN WIZARD
    // ==========================================
    wizard: {
        title: "Envoyer des Invitations",
        step1: "Contacts",
        step2: "Révision",
        step3: "Envoi",
        addContacts: "Ajouter des Contacts",
        importFromFile: "Importer depuis un Fichier",
        pasteContacts: "Coller les Contacts",
        manualEntry: "Saisie Manuelle",
        uploadCSV: "Télécharger CSV",
        uploadVCard: "Télécharger vCard",
        dragDropHere: "Glissez les fichiers ici ou cliquez pour parcourir",
        supportedFormats: "Formats supportés : CSV, VCF (vCard)",
        contactsAdded: "contacts ajoutés",
        reviewContacts: "Réviser les Contacts",
        removeSelected: "Supprimer la Sélection",
        selectAll: "Tout Sélectionner",
        deselectAll: "Tout Désélectionner",
        messageTemplate: "Modèle de Message",
        personalizeMessage: "Personnaliser le Message",
        previewMessage: "Aperçu du Message",
        sendVia: "Envoyer par",
        email: "Email",
        whatsapp: "WhatsApp",
        both: "Les Deux",
        schedule: "Programmer",
        sendNow: "Envoyer Maintenant",
        scheduleLater: "Programmer pour Plus Tard",
        confirmSend: "Confirmer l'Envoi",
        sending: "Envoi en cours...",
        sent: "Envoyé",
        failed: "Échec",
        cancel: "Annuler",
        back: "Retour",
        next: "Suivant",
        finish: "Terminer"
    },

    // ==========================================
    // EXPORT TAB
    // ==========================================
    export: {
        title: "Exporter les Données",
        exportCSV: "Exporter en CSV",
        exportLanguage: "Langue d'Export",
        original: "Original (Non traduit)",
        selectLanguage: "Sélectionner la langue...",
        exportAll: "Tout Exporter",
        exportFiltered: "Exporter les Filtrés",
        downloading: "Téléchargement...",
        downloadComplete: "Téléchargement terminé",
        noDataToExport: "Aucune donnée à exporter"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "Modifier la Réponse",
        deleteResponse: "Supprimer l'invité",
        confirmDelete: "Êtes-vous sûr de vouloir supprimer cette réponse ? Cette action est irréversible.",
        sendReminder: "Envoyer un Rappel Intelligent",
        reminderDesc: "Les destinataires sont filtrés selon le suivi des messages.",
        recipients: "Destinataires",
        customMessage: "Message Personnalisé (optionnel)",
        customMessagePlaceholder: "Ajoutez une note personnelle...",
        scheduledReminders: "Configurer les Rappels Programmés",
        enableReminders: "Activer les Rappels Programmés",
        reminderTiming: "Quand envoyer les rappels :",
        oneDay: "1 jour avant",
        threeDays: "3 jours avant",
        oneWeek: "1 semaine avant",
        twoWeeks: "2 semaines avant",
        contactStatus: "Statut des Contacts",
        allContacts: "Tous les Contacts",
        respondedFilter: "Ont Répondu",
        pendingFilter: "Réponse en Attente",
        doubleResponse: "Double Réponse ⚠️",
        emailStatus: "Statut Email",
        whatsappStatus: "Statut WhatsApp",
        translating: "Traduction des Réponses",
        translatingTo: "Traduction des réponses en"
    },

    // ==========================================
    // USER EVENTS
    // ==========================================
    events: {
        myEvents: "Mes Événements",
        noEvents: "Aucun Événement Trouvé",
        noEventsDesc: "Vous n'avez pas encore créé de formulaire RSVP.",
        createFirst: "Créer Votre Premier Événement",
        created: "Créé",
        eventId: "ID de l'Événement",
        viewResponses: "Voir les Réponses",
        loadingEvents: "Chargement de vos événements...",
        errorLoading: "Erreur lors du chargement de vos événements"
    },

    // ==========================================
    // AUTH
    // ==========================================
    auth: {
        signIn: "Connexion",
        signInDesc: "Connectez-vous pour voir vos formulaires",
        signInPrompt: "Connectez-vous pour accéder",
        loginWithEmail: "Se connecter avec email",
        loginWithGoogle: "Continuer avec Google",
        loginWithApple: "Continuer avec Apple",
        or: "ou",
        noAccount: "Pas de compte ?",
        createAccount: "Créer un compte"
    },

    // ==========================================
    // COMMON
    // ==========================================
    common: {
        loading: "Chargement...",
        save: "Enregistrer",
        cancel: "Annuler",
        close: "Fermer",
        delete: "Supprimer",
        edit: "Modifier",
        confirm: "Confirmer",
        send: "Envoyer",
        search: "Rechercher",
        filter: "Filtrer",
        refresh: "Actualiser",
        backToEvents: "Retour à Mes Événements",
        backToAccess: "Retour aux Options d'Accès",
        selectEvent: "Sélectionner un Événement",
        selectEventDesc: "Veuillez sélectionner un événement spécifique dans le menu déroulant ci-dessus.",
        error: "Erreur",
        success: "Succès",
        warning: "Avertissement",
        info: "Information",
        guests: "invités"
    },

    // ==========================================
    // UPGRADE PROMPTS
    // ==========================================
    upgrade: {
        unlockResponses: "Débloquer Toutes les Réponses",
        freeLimit: "Vous pouvez voir jusqu'à 25 réponses.",
        upgradeForUnlimited: "Mettez à niveau pour une visualisation illimitée →",
        upgradeRequired: "Mise à Niveau Requise"
    },

    // ==========================================
    // ANALYTICS INSIGHTS (Dynamic JS Content)
    // ==========================================
    insights: {
        // Pattern Insights
        peakResponseDay: "Jour de Pointe des Réponses",
        peakResponseTime: "Heure de Pointe des Réponses",
        responseMomentum: "Élan des Réponses",
        attendanceRate: "Taux de Présence",
        daysUntilEvent: "Jours Avant l'Événement",
        eventDay: "Jour de l'Événement",

        // Velocity labels
        pickingUp: "En Hausse",
        slowingDown: "En Baisse",
        steadyPace: "Rythme Stable",
        responsesComing: "Les réponses arrivent plus vite récemment",
        responseDecreased: "Le taux de réponse a diminué",
        consistentRate: "Taux de réponse constant",

        // Smart Insights
        excellentResponseRate: "Excellent Taux de Réponse",
        lowResponseRate: "Faible Taux de Réponse",
        highGuestMultiplier: "Fort Multiplicateur d'Invités",
        lowerGuestImpact: "Impact d'Invités Plus Faible",
        attendanceConcerns: "Préoccupations de Présence",
        strongAttendance: "Fort Engagement de Présence",

        // Insight descriptions
        respondedWellAbove: "des invités ont répondu - bien au-dessus de la moyenne !",
        onlyResponded: "Seulement ont répondu. Pensez à envoyer des rappels.",
        guestImpact: "d'impact d'invités - les gens amènent des accompagnants !",
        ensureVenue: "Assurez-vous que le lieu et le traiteur peuvent gérer une affluence plus importante.",
        fewerPlusOnes: "d'impact d'invités suggère moins d'accompagnants que prévu.",
        encourageCompanions: "Envisagez d'encourager les invités à amener des accompagnants.",
        respondentsAttending: "des répondants seront présents.",
        investigateBarriers: "Examinez les conflits potentiels ou problèmes avec la date/lieu de l'événement.",
        showsStrongInterest: "de taux de présence montre un fort intérêt pour votre événement !",

        // Activity insights
        greatMomentum: "Excellent Élan !",
        activeResponses: "Réponses Actives",
        recentActivity: "Activité Récente",
        responsesThisWeek: "réponses cette semaine avec un rythme accéléré - votre diffusion fonctionne",
        responsesLast7Days: "réponses au cours des 7 derniers jours - bon engagement",
        responseInLast: "réponse(s) au cours des 7 derniers jours",

        // Prediction
        expectedFinalAttendance: "Présence Finale Attendue",
        projecting: "Projection de",
        totalGuests: "invités au total basé sur les tendances actuelles",
        highConfidence: "haute confiance",
        moderateConfidence: "confiance modérée",
        earlyEstimate: "estimation précoce",
        getMoreResponses: "Obtenez plus de réponses pour améliorer la précision",

        // Event countdown
        finalCountdown: "Compte à Rebours Final !",
        comingSoon: "Bientôt",
        timeToPrepare: "Temps de préparer",
        daysRemaining: "jour(s) restant(s)",
        eventIsToday: "Votre événement est aujourd'hui !",

        // Additional insights
        highResponseVelocity: "Haute Vélocité de Réponse",
        responsesLast24h: "réponses dans les dernières 24 heures suggèrent un fort engagement",
        optimalCommunicationDay: "Jour de Communication Optimal",
        showsResponses: "montre",
        ofResponses: "des réponses - idéal pour les suivis",
        scheduleRemindersOn: "Programmez les rappels futurs pour un taux de réponse maximal",
        slowResponseCollection: "Collecte de Réponses Lente",
        averagingResponses: "Moyenne de",
        responsesPerDay: "réponses par jour en",
        days: "jours",
        considerDeadline: "Envisagez des messages d'urgence ou des incitations pour accélérer les réponses",
        timeForFollowUp: "Temps pour un Suivi",
        noResponsesIn: "Aucune réponse depuis",
        reminderCouldBoost: "jours - un rappel pourrait relancer l'engagement",

        // Engagement insights
        highDetailEngagement: "Fort Engagement de Détails",
        providedDietary: "ont fourni des informations alimentaires - invités très engagés",
        groupEventPattern: "Schéma d'Événement de Groupe",
        bringingPeople: "Les invités amènent",
        peopleOnAverage: "personnes en moyenne - planifiez pour des groupes",
        ensureSeating: "Assurez les places et le traiteur pour les tailles de groupes",
        lowFieldCompletion: "Faible Complétion des Champs",
        hasLowCompletion: "a une faible complétion",
        haveLowCompletion: "ont une faible complétion",
        considerRequired: "Envisagez de rendre les champs clés obligatoires",

        // Final week
        finalWeekPush: "Effort de Dernière Semaine Nécessaire",
        eventIn: "Événement dans",
        daysWithOnly: "jours avec seulement",
        responseRateLabel: "taux de réponse",
        attendanceRateLabel: "taux de présence",
        sendUrgentReminder: "Envoyez un rappel urgent final pour maximiser les confirmations",
        finalPlanningWindow: "Fenêtre de Planification Finale",
        daysLeft: "jours restants - temps pour le décompte final et la logistique",
        finalizeCatering: "Finalisez les quantités de traiteur et envoyez les détails aux invités confirmés",

        // Chart Labels
        adults: "Adultes",
        children: "Enfants",
        guests: "Invités",
        dietary: "Exigences Alimentaires",
        relationship: "Relation",
        attending: "Présents",
        maybe: "Peut-être",
        notAttending: "Absents",
        noResponse: "Sans Réponse",

        // Activity
        someone: "Quelqu'un",
        confirmedAttendance: "a confirmé sa présence",
        declined: "a décliné",
        fromBulk: "de masse",
        manual: "manuel",
        fromBulkMessaging: "de la messagerie en masse",
        clickToAdjust: "Cliquer pour ajuster",
        sendBulkToUnlock: "Envoyez des messages pour débloquer cette métrique",
        guestsConfirmed: "invités confirmés sur",
        invitations: "invitations",
        day: "jour",
        untilEvent: "jusqu'à l'événement",

        // Saturation
        responseSaturation: "Saturation des Réponses Atteinte",
        patternSuggests: "Le schéma suggère que vous avez capturé la plupart des réponses disponibles",

        // Live Activity
        liveUpdates: "Mises à Jour en Direct",
        live: "En Direct",
        reached: "Atteint",
        responses: "réponses !",
        latest: "Récent",

        // Day names
        sunday: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",

        // Time ranges
        morning: "Matin (6h-12h)",
        afternoon: "Après-midi (12h-18h)",
        evening: "Soir (18h-22h)",
        night: "Nuit (22h-6h)",

        // Yes/No/Maybe
        yes: "oui",
        no: "non",

        // Smart insights empty state
        smartInsightsWillAppear: "Les insights intelligents apparaîtront lorsque plus de réponses arriveront..."
    },

    // ==========================================
    // BULK SHARING WIZARD (Full UI)
    // ==========================================
    bulkWizard: {
        // Builder-mount success screen (first send from the Share step).
        remindersOnDashboard: "Les rappels, l'état de livraison et les relances se trouvent dans votre tableau de bord.",
        goToDashboard: "Ouvrir le tableau de bord",
        outcomeScheduledTitle: "Message programmé",
        outcomeScheduledBody: "Votre message partira le {date}.",
        outcomeApprovalTitle: "En attente de l’approbation de WhatsApp",
        outcomeApprovalBody: "WhatsApp vérifie chaque nouveau message avant son envoi, généralement en quelques minutes. Vos invités WhatsApp le recevront dès qu’il sera approuvé, vous n’avez rien d’autre à faire.",
        outcomeApprovalOthersSent: "Les invités qui le reçoivent par e-mail ou SMS sont en train de le recevoir.",
        outcomeHeldTitle: "Votre premier message est en cours de vérification",
        outcomeHeldBody: "Il s’agit d’une vérification unique lors d’un premier envoi. Nous vous écrirons dès qu’il sera validé. Rien n’a été envoyé et aucun crédit n’a été utilisé.",
        outcomeRefusedTitle: "WhatsApp n’a pas accepté ce message",
        outcomeRefusedReason: "Motif indiqué par WhatsApp : {reason}",
        outcomeRefusedOthersNow: "Les invités qui le reçoivent par e-mail ou SMS le reçoivent quand même.",
        outcomeRefusedOthersScheduled: "Les invités qui le reçoivent par e-mail ou SMS le recevront quand même le {date}.",
        outcomeRefusedNoOthers: "Aucun de vos invités ne l’a encore reçu.",
        outcomeRefusedFix: "Pour toucher vos invités WhatsApp, modifiez le message depuis votre tableau de bord et renvoyez-le. WhatsApp vérifiera le nouveau texte.",
        tplErr_trailingParam: "Votre message ne peut pas SE TERMINER par une balise de personnalisation comme {{name}} ou {{table_number}}. WhatsApp ne l'autorise pas. Ajoutez un mot ou un point après la balise et renvoyez-le.",
        tplErr_waLink: "WhatsApp n'autorise pas un bouton qui renvoie vers WhatsApp. Faites pointer ce bouton ailleurs et renvoyez le message.",
        tplErr_imageFormat: "Pour WhatsApp, l'image de votre invitation doit être au format JPG ou PNG. Téléversez-la à nouveau dans ce format et renvoyez le message.",
        tplErr_imageProcess: "WhatsApp n'a pas pu traiter l'image de votre invitation. Essayez-en une autre (JPG ou PNG, moins de 5 Mo) et renvoyez le message.",
        tplErr_category: "WhatsApp considère votre message comme d'un autre type que celui sous lequel nous l'avons classé. Renvoyez-le et il devrait passer.",
        tplErr_layout: "WhatsApp n'a pas pu lire la mise en page de votre message. C'est généralement une {{balise}} seule sur sa ligne. Placez-la dans une phrase et renvoyez le message.",
        tplErr_duplicateName: "WhatsApp a déjà un message enregistré sous ce nom. Renommez le message et renvoyez-le.",
        tplErr_rateLimit: "Vous avez atteint pour l'instant la limite de nouveaux messages de WhatsApp. Patientez un peu et renvoyez-le. Rien n'est perdu.",
        outcomeSubmitFailedTitle: "Nous n’avons pas encore pu transmettre votre message à WhatsApp pour approbation",
        close: "Fermer",
        outcomeSubmitFailedBody: "Nous réessaierons automatiquement et vous écrirons si WhatsApp le refuse. Vous n’avez rien à faire pour l’instant.",
        outcomeVerifyTitle: "Confirmez votre adresse e-mail pour l’envoyer",
        outcomeVerifyBody: "Votre message est enregistré, mais rien n’a encore été envoyé. Confirmez votre adresse e-mail (dans l’onglet Partager de votre formulaire) et il partira automatiquement.",
        outcomeUpgradeTitle: "Une mise à niveau est nécessaire avant l’envoi",
        outcomeUpgradeBody: "Cet événement utilise des fonctionnalités de son modèle qui nécessitent une mise à niveau. Mettez-le à niveau depuis son tableau de bord et votre message partira automatiquement. Rien n’a encore été envoyé.",
        outcomePausedTitle: "Votre message n’est pas encore parti",
        outcomePausedBody: "Il est enregistré, mais rien n’a encore été envoyé. Vous pouvez suivre son statut dans votre tableau de bord.",
        sendBlockedBlanks: "Votre message contient encore des champs du modèle à compléter : {blanks}",
        sendDateMissing: "Choisissez une date pour votre message programmé.",
        sendDatePast: "La date et l’heure prévues sont déjà passées. Choisissez un moment à venir.",
        // Initial loading
        checkingAccess: "Vérification des droits d'accès...",
        wizardFailedToLoad: "L'assistant de messages n'a pas pu charger. Veuillez rafraîchir la page.",

        // Progress steps
        step1Contacts: "1. Contacts",
        step2Channels: "2. Canaux",
        step2Review: "3. Personnaliser",
        step3FollowUp: "4. Suivi",
        step4Send: "5. Envoi",

        // Navigation buttons
        previous: "Précédent",
        next: "Suivant",
        nextChannels: "Suivant : Canaux d'envoi",
        nextCustomize: "Suivant : Personnaliser",
        nextFinalize: "Suivant : Finaliser et Envoyer",
        skip: "Passer",
        saveAsDraft: "Enregistrer comme brouillon",

        // Contacts step
        uploadContactList: "Importer une liste de contacts",
        uploadContactsDesc: "Importez des contacts au format CSV ou vCard",
        dragDropFile: "Glissez-déposez le fichier ici",
        orClickToBrowse: "ou cliquez pour parcourir",
        chooseFile: "Choisir un fichier",
        csvOrVcard: "CSV ou vCard (.vcf)",
        manuallyAddContacts: "Ajouter des contacts manuellement",
        csvTemplate: "Modèle CSV",
        vcardTemplate: "Modèle vCard",

        // Phone tip
        phoneTip: "Les numéros de téléphone doivent inclure l'indicatif pays (ex: +33612345678). Si vous utilisez Excel, formatez la colonne comme 'Texte' pour éviter les problèmes de formatage.",

        // Sending method
        sendVia: "Envoyer via",
        channelEmail: "Email",
        channelEmailTooltip: "Envoyer par email. Si pas d'email, le mobile sera utilisé.",
        channelMobile: "Mobile (WhatsApp/SMS)",
        channelMobileTooltip: "Envoyer par WhatsApp, avec SMS en secours. Si pas de téléphone, l'email sera utilisé.",
        channelHint: "1 crédit par canal. Le système bascule vers d'autres canaux si la livraison échoue.",
        deliveryMethod: "Mode d'envoi",
        smartDeliveryLabel: "Envoi intelligent",
        smartDeliveryShortDesc: "WhatsApp/SMS si disponible, sinon par email.",
        smartDeliveryCreditNote: "1 crédit par contact.",
        customizeDelivery: "Personnaliser",
        channelsStepTitle: "Vérifiez les canaux d'envoi",
        channelsStepSubtitle: "Choisissez comment vos invités recevront cette invitation.",
        usNumbersDeliveryNote: "🇺🇸 Note sur les numéros américains : Meta ne prend pas en charge l'envoi groupé de WhatsApp vers les numéros américains ; ces messages basculeront donc automatiquement vers des SMS standard. Les numéros canadiens commencent aussi par +1 mais ne sont pas concernés : ils reçoivent WhatsApp. Si vos invités possédant un numéro américain se trouvent actuellement à l'étranger, nous vous recommandons vivement d'ajouter une adresse e-mail pour garantir la distribution.",
        deliveryModalTitle: "Comment livrer les invitations ?",
        deliveryOptionSmart: "Envoi intelligent",
        deliveryOptionSmartTag: "Recommandé",
        deliveryOptionSmartDesc: "WhatsApp pour les contacts hors États-Unis, SMS pour les contacts aux États-Unis, et email pour les contacts sans téléphone. 1 crédit par contact.",
        deliveryOptionEmail: "Email d'abord",
        deliveryOptionEmailDesc: "Privilégie l'envoi par email. Utilise automatiquement le mobile si aucun email n'est fourni.",
        deliveryOptionMobile: "Mobile d'abord",
        deliveryOptionMobileDesc: "Privilégie l'envoi par mobile (WhatsApp/SMS). Utilise automatiquement l'email si aucun numéro de téléphone n'est fourni.",
        deliveryOptionBoth: "Les deux canaux",
        deliveryOptionBothDesc: "Envoyer à la fois par email et par mobile lorsque les deux sont disponibles.",
        deliveryOptionBothCost: "1 crédit par contact, même avec les deux canaux.",
        deliveryDoneBtn: "Enregistrer",
        deliveryCancelBtn: "Annuler",
        usWhatsappShortNotice: "WhatsApp en masse n'est pas autorisé pour les numéros américains (politique Meta).",

        // SMS consent
        consentNotice: "Vos invités peuvent payer des frais de message et de données (la fréquence varie) et peuvent répondre STOP pour se désabonner, HELP pour l'aide.",
        usWhatsappNotice: "Selon la politique actuelle de Meta, les numéros de téléphone américains ne peuvent pas recevoir de messages WhatsApp en masse et basculeront automatiquement vers SMS. Vous pouvez toujours envoyer des messages individuels aux numéros américains via WhatsApp.",
        smsConsentCheckbox: "Je confirme que tous les destinataires ont consenti à recevoir des messages SMS d'invitation à mon événement via QuikRSVP.",
        smsConsentDisclosure: "Les destinataires peuvent répondre STOP pour se désabonner ou HELP pour obtenir de l'aide. Des frais de données et de messagerie peuvent s'appliquer. La fréquence varie.",
        smsConsentRequired: "Vous devez confirmer le consentement des destinataires avant l'envoi.",
        termsConsentRequired: "Vous devez accepter les Conditions Générales et la Politique de Confidentialité avant l'envoi.",
        smsConsentEmailFallbackHint: "Aucune adresse e-mail pour {n} de vos invités : le message sera donc envoyé sur leur téléphone, éventuellement par SMS.",
        smsConsentEditTitle: "Confirmer le consentement SMS",
        smsConsentEditBody: "Certains invités de ce message ont un numéro américain, un autre numéro +1 ou un numéro brésilien : ils peuvent donc le recevoir par SMS. Confirmez leur consentement pour enregistrer vos modifications.",
        smsConsentEditSave: "Confirmer et enregistrer",
        termsLink: "Conditions Générales",
        privacyLink: "Politique de Confidentialité",

        // Contact summary
        valid: "valides",
        invalid: "invalides",
        messages: "messages",
        editContacts: "Modifier les contacts",
        invalidContacts: "Contacts invalides :",

        // Follow-up banner
        followUpCampaign: "Message de suivi",
        contactsAutoLoaded: "contacts ont été chargés automatiquement depuis votre message précédent.",
        filterApplied: "Filtre appliqué :",
        startFresh: "Recommencer à zéro",

        // File parsing
        dragDropCsv: "Glissez-déposez le fichier CSV ici ou cliquez pour parcourir",
        dragDropVcard: "Glissez-déposez le fichier vCard ici ou cliquez pour parcourir",
        csvColumns: "Colonnes : Nom(s) des invités, Nom du groupe, Téléphone, E-mail (facultatif : Invités max, Étiquettes)",
        downloadCsvTemplate: "Télécharger le modèle CSV",
        downloadVcardTemplate: "Télécharger le modèle vCard",
        vcardFromSources: "Fichier .vcf standard provenant de sources comme Google Contacts ou Outlook.",

        // Send step
        readyToSend: "Prêt à envoyer !",
        reviewAndSend: "Vérifiez les détails de votre message et envoyez vos invitations.",
        campaignSummary: "Résumé du message",
        totalMessages: "Total des messages",
        emailLabel: "Email",
        mobileLabel: "Mobile",

        // Reminders
        remindersEnabled: "Rappels activés :",

        // Credits
        messageCredits: "Crédits de messages",
        yourBalance: "Votre solde",
        creditsNeeded: "Crédits nécessaires",
        readyToSendCredits: "Prêt à envoyer ! Vous avez suffisamment de crédits pour ce message.",
        needMoreCredits: "Vous avez besoin de plus de crédits.",
        purchasePackage: "Achetez un pack pour continuer.",

        // Send timing
        sendTiming: "Planification de l'envoi",
        sendImmediately: "Envoyer immédiatement",
        messagesQueuedNow: "Les messages seront mis en file d'attente immédiatement",
        scheduleForLater: "Programmer pour plus tard",
        chooseDateTime: "Choisissez une date et une heure spécifiques",
        date: "Date",
        time: "Heure",
        schedulingNote: "L'heure de livraison est approximative et n'est pas garantie. Les messages seront mis en file d'attente pour traitement à l'heure prévue.",

        // Buttons
        sendCampaign: "Envoyer aux invités",
        upgradeAndBuyCredits: "Mettre à niveau et acheter des crédits",
        buyCredits: "Acheter des crédits",

        // Credits info
        creditsInfo: "Les crédits sont comptés par invité, pas par message • Les crédits n'expirent jamais • Fonctionnent sur tous les formulaires",
        // Send step: guests per channel and the one cost line (_deliveryPlanHtml).
        deliveryPlanTitle: "Comment vos invités le recevront",
        deliveryWhatsapp: "WhatsApp",
        deliverySms: "SMS",
        deliveryEmail: "E-mail",
        deliveryGuestsOne: "1 invité",
        deliveryGuestsMany: "{n} invités",
        deliveryFullDesc: "Votre message complet, avec l'image et les boutons éventuels que vous avez ajoutés",
        deliverySmsDesc: "Texte seul : ni image ni boutons. Vos liens sont envoyés sous forme d'adresses web.",
        deliverySmsDescNoLink: "Texte seul : ni image, ni boutons, ni liens.",
        deliverySmsWhy: "Les numéros américains reçoivent un SMS, car WhatsApp ne distribue pas ce type d'invitation aux numéros américains.",
        deliverySmsPreview: "Voir le SMS qu'ils recevront",
        deliverySmsCantSend: "Ces invités ne recevront pas de SMS : un SMS ne peut contenir que des lettres latines, et ce message n'en a aucune. Ajoutez une version anglaise de votre message à l'étape Personnaliser pour les joindre.",
        deliverySmsEmailOnlyOne: "1 d'entre eux a une adresse e-mail et recevra seulement l'e-mail.",
        deliverySmsEmailOnlyMany: "{n} d'entre eux ont une adresse e-mail et recevront seulement l'e-mail.",
        deliverySmsNothingOne: "1 invité ne recevra rien.",
        deliverySmsNothingMany: "{n} invités ne recevront rien.",
        costLabel: "Coût",
        costCreditsOne: "1 crédit",
        costCreditsMany: "{n} crédits",
        costPerGuest: "1 crédit par invité",
        costPerGuestTicketed: "1 crédit par invité joint par téléphone ; les e-mails sont gratuits pour les événements avec billets",
        balanceAfterSending: "Solde après l'envoi : {n}",
        costUnsentNote: "Les crédits réservés pour les invités qui ne reçoivent rien vous sont rendus après l'envoi.",
        remindersCostNote: "Chaque rappel coûte 1 crédit par invité joint, au moment de son envoi.",
        remindersCostNoteTicketed: "Chaque rappel coûte 1 crédit par invité joint par téléphone, au moment de son envoi. Les e-mails sont gratuits.",
        notEnoughCreditsToSend: "Crédits insuffisants : vous en avez {balance} et ce message en nécessite {needed}. Achetez des crédits, puis relancez l'envoi.",

        // Contact editor modal
        contactEditor: "Éditeur de contact",
        name: "Nom",
        email: "E-mail",
        phone: "Téléphone",
        actions: "Actions",
        addNewContact: "Ajouter un nouveau contact",
        saveContacts: "Enregistrer les contacts",
        cancel: "Annuler",

        // Validation
        contactsCleared: "Contacts effacés. Vous pouvez maintenant importer une nouvelle liste.",

        // Review step labels
        composeYourMessage: "Rédiger votre message",
        composeSubtitle: "Personnalisez votre invitation et choisissez comment les invités la recevront.",
        messageAndTranslations: "Message et traductions",
        customEmailSettings: "Réglages e-mail",
        buttonsLinks: "Boutons et liens",
        linksButtonsLabel: "Liens / boutons",
        buttonsLinksHint: "Choisissez jusqu'à 2 boutons à inclure dans votre message.",
        campaignButtonsMax: "Vous pouvez inclure jusqu'à 2 boutons par message",
        buttonCaptionAlsoIn: "Envoyé aussi en {n}",
        buttonCaptionAsTyped: "Votre formulation — envoyée telle quelle",
        buttonCaptionPairTip: "Les deux langues figurent ensemble sur le bouton. Si la paire dépasse les 25 caractères autorisés par WhatsApp, une seule est conservée — regardez l'aperçu pour voir le texte exact.",
        buttonLabelOptional: "Libellé du bouton (facultatif)",
        buttonAppearsOn: "Les boutons apparaissent sur WhatsApp et par e-mail.",
        rsvpTargetLabel: "Où le lien de réponse doit-il mener ?",
        rsvpTargetForm: "Formulaire QuikRSVP",
        rsvpTargetWebsite: "Mon site de mariage",
        campaignName: "Nom du message",
        campaignNamePlaceholder: "Nommez votre message…",
            campaignNameDefaultDescriptor: "Invitations",
        campaignNameHelp: "Donnez un nom à ce message pour l'identifier plus tard",
        campaignNameDuplicate: "Un message portant ce nom existe déjà. Choisissez un nom unique (par exemple, ajoutez « - Groupe B »), ou ajoutez des contacts à votre message existant.",
        campaignNameDupShort: "Un message portant ce nom existe déjà.",
        campaignNameDupViewExisting: "Voir le message existant",
        emailSubjectLine: "Objet de l'email",
        emailSenderName: "Nom de l'expéditeur",
        emailSenderNameHelp: "Nom affiché aux invités",
        replyToLabel: "Les réponses vont à",
        replyToDefaultSuffix: "par défaut",
        replyToAddOption: "Utiliser une autre adresse…",
        replyToNewPlaceholder: "nom@exemple.com",
        replyToSendVerify: "Envoyer la confirmation",
        replyToSending: "Envoi…",
        replyToSent: "Confirmation envoyée. Ouvrez cette boîte, cliquez sur le lien, puis choisissez l’adresse ici.",
        replyToRecheck: "C’est confirmé",
        replyToAlreadyVerified: "Cette adresse est déjà confirmée — choisissez-la dans la liste.",
        replyToInvalid: "Saisissez une adresse e-mail valide.",
        replyToError: "Impossible d’envoyer la confirmation. Veuillez réessayer.",
        replyToWhyVerify: "Nous confirmons l’adresse au préalable afin qu’une invitation ne puisse pas rediriger les réponses vers une boîte que l’expéditeur ne contrôle pas.",
        emailThemeColor: "Couleur de l'email",
        emailLogo: "Logo de l'email",
        emailLogoUpload: "Télécharger",
        emailLogoHide: "Masquer",
        emailLogoShow: "Afficher",
        emailLogoReset: "Utiliser le logo QuikRSVP",
        emailLogoPaidOnly: "Formules payantes",
        emailLogoUpgradeMsg: "Le logo personnalisé est disponible avec les formules payantes — passez à une formule supérieure pour le personnaliser.",
        messageHeader: "En-tête d'invitation",
        messageHeaderHelp: "Titre en gras en haut de votre email et WhatsApp. Supprimez pour masquer.",
        invitationTagline: "Sous-titre d'invitation",
        invitationTaglineHelp: "Texte plus petit sous l'en-tête (p. ex. \"Vous êtes invité\"). Supprimez pour masquer. (email uniquement)",
        headerAndSubject: "Titre, sous-titre et objet",
        leaveBlankToHide: "Laissez vide pour masquer",
        yourMessage: "Votre message",
        writeMessagePlaceholder: "Écrivez votre message d'invitation ici...",
        characters: "caractères",
        translateTo: "Traduire vers :",
        translate: "Traduire",
        translationWillAppear: "La traduction apparaîtra ici...",
        // Message & Translations block (task #453)
        translateHint: "Envoyez cette invitation dans une autre langue",
        translationsReady: "Traductions prêtes",
        messageLanguages: "Langues du message",
        yourMessageBadge: "Votre message",
        hide: "Masquer",
        view: "Afficher",
        addAnotherLanguage: "Ajouter une autre langue",
        chooseLanguage: "Choisir…",
        willSendAsWritten: "Les invités reçoivent {a} — le message tel que vous l'avez écrit",
        willSendTranslationOnly: "Les invités reçoivent uniquement {a} — votre original n'est pas envoyé",
        willSendBoth: "Les invités reçoivent {a} et {b} ensemble dans un seul message",
        oneTranslationOnly: "Un message contient votre original et une traduction. Décochez d'abord {lang}.",
        pickAtLeastOneLanguage: "Choisissez au moins une langue d'envoi.",
        addLanguageToTranslate: "Choisissez une langue de traduction.",
        emptyLanguageBlocked: "Ajoutez du texte pour {langs}, ou décochez la langue.",
        emptyLanguagesBlocked: "Ajoutez du texte pour ces langues, ou décochez-les : {langs}.",
        smsNotSendable: "non envoyable par SMS",
        smsSourceOnly: "Le SMS n'envoie que votre original",
        smsSendsTranslation: "Le SMS envoie votre traduction à la place",
        waCombinedOver: "Les deux langues partagent un seul message WhatsApp — {n} sur 1 024 caractères. Raccourcissez-en une.",
        bothWillBeSent: "L'original et la traduction seront envoyés",
        onlyTranslationWillBeSent: "Seule la traduction sera envoyée",
        sendAsWrittenDesc: "Le message est déjà dans la langue des invités",
        sendTranslatedOnly: "Envoyer uniquement la version traduite",
        bilingual: "Bilingue",
        sendBilingual: "Envoyer les deux (original et traduction) dans un seul message",
        multiLanguageHint: "Besoin de contacter des invités dans différentes langues séparément ? Créez un message pour chaque langue.",
        preview: "Aperçu",
        addImage: "Ajouter une image",
        changeImage: "Changer l'image",
        convertingImage: "Conversion de la photo iPhone…",
        processingImage: "Traitement de l'image…",
        uploadingImage: "Téléversement…",
        invitationImage: "Image d'invitation",
        invitationImageDesc: "Facultatif — affichée en haut de votre e-mail et de votre message WhatsApp.",
        invitationSplashLabel: "Ouvrir en plein écran au toucher",
        invitationSplashDesc: "Les invités qui touchent votre invitation dans WhatsApp la voient en grand, puis votre formulaire de réponse.",
        beforeYouSend: "Avant l'envoi",
        goodToKnow: "Notes sur les crédits et la livraison",
        optionalLabel: "facultatif",
        csvFormattingTips: "Conseils de format CSV",
        downloadTemplate: "Télécharger un modèle",
        previewShowsExactly: "L'aperçu montre exactement ce que les invités recevront.",

        // What happens next
        whatHappensNext: "Que se passe-t-il ensuite ?",

        // Success states
        campaignCreated: "Message créé !",
        messagesQueued: "messages en file d'attente",
        scheduledFor: "Programmé pour",
        tip: "Conseil",

        // Follow-up reminders step
        followUpRemindersTitle: "Rappels de Suivi",
        followUpRemindersDesc: "Programmez des rappels automatiques pour vos invités",
        saveAndResubmitWhatsApp: "Enregistrer et renvoyer à WhatsApp",
        saveAndResend: "Enregistrer et renvoyer",
        saveAndResubmitHint: "Renvoie votre message modifié à WhatsApp pour approbation. Il partira aux invités qui ne l’ont jamais reçu.",
        saveAndResendHint: "Enregistre votre message modifié et l’envoie aux invités qui ne l’ont jamais reçu.",
        // Edit & Resend feedback: the save is instant, the WhatsApp
        // re-submission is not, so they are reported separately (task #592).
        editSavedChanges: "Modifications enregistrées.",
        editSavedResubmitting: "Modifications enregistrées. Envoi de votre message à WhatsApp pour approbation…",
        translationStale: "Votre message a changé après cette traduction. Mettez la traduction à jour.",
        translateAgain: "Traduire à nouveau",
        translationStaleBlocked: "Vous avez modifié votre message après l'avoir traduit. Mettez à jour la traduction en {lang} avant l'envoi : appuyez sur Traduire à nouveau, ou modifiez-la vous-même.",
        translationStaleWarn: "Vous avez modifié votre message après l'avoir traduit. Vérifiez que la traduction en {lang} correspond toujours.",
        editSavedRescheduled: "Modifications enregistrées. Votre message partira le {date}.",
        editTimingUseSend: "Modifications enregistrées. Votre message est toujours programmé pour le {date}. Pour l'envoyer maintenant, appuyez sur Envoyer.",
        editSavedNotSent: "Modifications enregistrées. Rien n'a encore été envoyé. Pour l'envoyer, ouvrez Modifier et renvoyer, puis appuyez sur Envoyer.",
        editSavedRescheduledPaused: "Modifications enregistrées. La nouvelle heure est le {date}. Le message reste en pause jusqu'à ce que vous le repreniez.",
        editTimingAfterReminder: "Un rappel de ce message est prévu le {date}. Choisissez une heure antérieure, ou modifiez d'abord le rappel.",
        editTimingPast: "Cette heure est déjà passée. Choisissez une heure à venir.",
        editTimingPickDate: "Choisissez une date et une heure pour l'envoi programmé.",
        editResubmitAccepted: "Votre message modifié est chez WhatsApp pour approbation. Il partira dès qu’il sera approuvé.",
        editResubmitRefused: "WhatsApp n’a pas accepté le message",
        sendTestSavedAsDraft: "Votre message a été enregistré comme brouillon pour envoyer ce test : vous le retrouverez dans votre liste de messages.",
        editBlockedSending: "Vos modifications n’ont pas été enregistrées : l’envoi de ce message a commencé. Une fois l’envoi terminé, ajoutez les nouveaux invités avec « Ajouter des contacts » sur sa carte.",
        editBlockedStale: "Vos modifications n’ont pas été enregistrées : ce message a changé pendant que vous le modifiiez (par exemple, des invités ont été ajoutés ou il a été envoyé). Fermez cette fenêtre et rouvrez-le pour modifier sa dernière version.",
        nextFollowUp: "Suivant : Suivi",
        addAnotherReminder: "Ajouter un Rappel",
        removeReminder: "Supprimer",
        reminderNumber: "Rappel",
        whenToSend: "Quand envoyer",
        sendTo: "À qui envoyer",
        reminderMessage: "Message",
        reminderButtonsLabel: "Boutons",
        reminderButtonRsvp: "Confirmation de présence",
        reminderRsvpAutoIncluded: "(lien inclus automatiquement)",
        reminderButtonRegistry: "Liste de cadeaux",
        reminderButtonDirections: "Itinéraire",
        reminderButtonWebsite: "Site du mariage",
        reminderButtonsHint: "Les boutons sont facultatifs — ajoutez-en jusqu'à 2, ou laissez tout décoché pour un rappel en texte simple.",
        reminderButtonLabelLangHint: "Laissé vide, chaque bouton s'affiche dans les deux langues, comme indiqué. Un libellé saisi est envoyé tel quel — écrivez les deux langues si vous voulez les deux.",
        reminderEditButton: "Modifier",
        reminderEditTitle: "Modifier le rappel",
        reminderNewTitle: "Nouveau rappel",
        reminderLinkedNote: "Envoyé comme rappel lié à \"{name}\" — et non comme un nouveau message.",
        reminderRecipientsFinalized: "Les destinataires sont déterminés au moment de l'envoi du rappel.",
        reminderFixedRecipientsNote: "Ce rappel sera envoyé aux {count} destinataires que vous avez sélectionnés.",
        reminderAudienceScopeNote: "Ce suivi sera envoyé <strong>uniquement</strong> aux destinataires de ce message précis, et non à tous les invités de votre événement.",
        reminderSendNowHint: "Par défaut maintenant — il partira sous peu (dès que WhatsApp approuve le message). Choisissez une date et une heure ultérieures pour le programmer.",
        reminderCancel: "Annuler",
        reminderSaveChanges: "Enregistrer les modifications",
        reminderCreateBtn: "Créer le rappel",
        reminderReviewContinue: "Continuer",
        reminderReviewPreviewNote: "Les personnes que vous retirez ici sont exclues de ce rappel uniquement ; vos autres rappels ne changent pas. Le reste de la liste est confirmé au moment de l'envoi — par exemple, les invités qui répondent d'ici là sont automatiquement exclus.",
        removeButton: "Retirer",
        linkChipUrlLabel: "Lien",
        linkChipLabelLabel: "Texte du bouton",
        linkChipSave: "Ajouter",
        linkChipUrlRequired: "Ajoutez un lien ou annulez.",
        remindAllTitle: "Envoyer un rappel",
        remindAllSubtitle: "{n} destinataires",
        remindAllPreConfigure: "Aucun invité ne correspond pour l'instant : ce rappel sera envoyé automatiquement aux personnes concernées au moment de l'envoi.",
        remindAllSendingTo: "Envoi à <strong>{n}</strong> invité(s) sélectionné(s).",
        remindAllAddedOptedOut: "Les rappels sont désactivés pour {n} invité(s) que vous avez ajouté(s) : ils ne recevront pas celui-ci.",
        remindAllContinue: "Continuer vers l'envoi",
        remindAllNextStepHint: "Vous choisirez le mode d'envoi et confirmerez le coût à l'étape suivante.",
        reminderUpdatedToast: "Rappel mis à jour",
        reminderResubmittedToast: "Rappel mis à jour et renvoyé à WhatsApp pour approbation.",
        reminderCreatedToast: "Rappel créé — il sera envoyé à l'heure prévue.",
        reminderSendingNowToast: "Votre rappel est en route — l'envoi est en cours.",
        reminderUpdateFailed: "Échec de la mise à jour du rappel : ",
        reminderCreateFailed: "Échec de la création du rappel : ",
        reminderAlertPickDateTime: "Veuillez choisir une date et une heure d'envoi.",
        reminderAlertTrailingTag: "Votre message ne peut pas se terminer par une balise de personnalisation comme {{table_number}} — WhatsApp ne l'autorise pas. Ajoutez quelques mots après (p. ex. « À bientôt ! »).",
        reminderAlertValidDateTime: "Veuillez saisir une date et une heure valides.",
        reminderAlertRegistryUrl: "Ajoutez une URL pour le lien de la liste de cadeaux, ou décochez-le.",
        reminderAlertDirectionsUrl: "Ajoutez une URL pour le lien d'itinéraire, ou décochez-le.",
        reminderAlertWebsiteUrl: "Ajoutez une URL pour le lien du site de mariage, ou décochez-le.",
        reminderAlertLivestreamUrl: "Ajoutez un lien pour la diffusion en direct, ou décochez-la.",
        reminderSendNowChoice: "Envoyer maintenant",
        reminderScheduleChoice: "Programmer pour plus tard",
        reminderGoesOutShortly: "Votre rappel partira sous peu (dès que WhatsApp aura approuvé le message).",
        reminderHourOnlyHint: "Les rappels sont envoyés à l'heure pile (les minutes ne sont pas prises en compte).",
        reminderIncludeImage: "Inclure la photo de l'invitation",
        reminderImageHeading: "Image",
        reminderTranslateLabel: "Envoyer aussi une traduction en {lang}",
        reminderTranslateHint: "Désactivé par défaut : votre rappel est envoyé tel quel. Activez-le pour le traduire et l'ajouter automatiquement.",
        useDifferentLink: "Utiliser un autre lien…",
        reminderIncludeThisImage: "Inclure cette image",
        reminderUseDifferentImage: "Utiliser une autre image",
        reminderCustomImageNote: "Ce rappel utilise une image différente de celle de l'invitation.",
        reminderButtonsMax: "Vous pouvez inclure jusqu'à 2 boutons par rappel.",
        reminderButtonUrlPlaceholder: "Collez un lien (https://...)",
        invalidButtonUrlWarning: "Ceci ne ressemble pas à un lien web valide. S'il s'agit d'une adresse, collez le lien depuis Google Maps — les liens non valides sont omis des messages WhatsApp.",
        reminderDirectionsUrlPlaceholder: "Lien Google Maps ou Waze",
        reminderButtonUrlMissing: "Ajoutez un lien pour le bouton sélectionné, ou désélectionnez-le.",
        resetToDefault: "Rétablir par défaut",
        guestsWhoHaventRSVPd: "Invités qui n'ont pas répondu",
        attendingGuests: "Invités qui participent",
        allGuests: "Tous les invités",
        guestsAnsweredMaybe: "Invités ayant répondu « Peut-être »",
        guestsDeclined: "Invités ayant répondu « Non »",
        twoWeeksBefore: "2 semaines avant l'événement",
        oneWeekBefore: "1 semaine avant l'événement",
        threeDaysBefore: "3 jours avant l'événement",
        oneDayBefore: "1 jour avant l'événement",
        dayOfEvent: "Le jour de l'événement",
        oneDayAfter: "Le lendemain de l'événement",
        threeDaysAfter: "3 jours après l'événement",
        reminderButtonAlbum: "Album photo des invités",
        reminderButtonLivestream: "Diffusion en direct",
        reminderLivestreamUrlPlaceholder: "Lien YouTube, Zoom ou Facebook Live",
        reminderAlbumOff: "Activez l'album dans l'onglet « Photos des invités » pour obtenir son lien.",
        customDate: "Date personnalisée",
        pickReminderDate: "Choisissez une date",
        reminderTime: "Heure",
        reminderTimeHint: "Envoyé à cette heure, dans votre fuseau horaire local.",
        guestNightWarning: "À noter : beaucoup de vos invités le recevront la nuit (vers {time} chez eux). L'envoi se fera quand même à l'heure choisie, mais en journée les réponses arrivent souvent plus vite.",
        reminderTimePast: "Choisissez une date et une heure à venir pour votre rappel personnalisé",
        reminderDateInvalid: "La date du rappel doit être au plus tard le jour de l'événement",
        reminderDateMissing: "Veuillez choisir une date pour votre rappel personnalisé",
        reminderNoEventDate: "Votre événement n’a pas encore de date : un rappel ne peut donc partir qu’à une date que vous choisissez. Choisissez « Date personnalisée », ou ajoutez la date de l’événement dans l’éditeur pour programmer les rappels à partir d’elle.",
        reminderAfterRsvpDeadline: "Les réponses seront closes avant l’envoi de ce rappel : il ne sera donc pas envoyé. Repoussez la date limite de réponse dans l’éditeur, choisissez une heure plus tôt ou retirez le lien de confirmation.",
        defaultReminderMessage: "Bonjour ! Juste un petit rappel amical — nous serions ravis d'avoir de vos nouvelles ! Veuillez confirmer votre présence quand vous le pourrez.",
        defaultAttendingMessage: "Nous avons hâte de vous voir ! Voici un petit rappel sur les détails de l'événement.",
        defaultMaybeMessage: "Bonjour ! Vous nous aviez dit que vous viendriez peut-être — avez-vous pu décider ? Nous aimerions une réponse définitive, oui ou non, afin de pouvoir nous organiser. Merci de mettre à jour votre réponse dès que possible.",
        creditsChargedNote: "Les crédits sont débités lors de l'envoi effectif de chaque rappel. Assurez-vous d'avoir suffisamment de crédits à ce moment-là.",
        skipFollowUpNote: "Vous pouvez ignorer cette étape et envoyer des suivis plus tard en créant un nouveau message depuis votre tableau de bord.",
        remindersConfigured: "rappel(s) programmé(s)",

        // Toast messages - Payment
        paymentSuccessClickMessage: "Paiement réussi ! Cliquez sur 'Envoyer aux invités' pour continuer.",
        paymentSuccessSendReady: "Paiement réussi ! Vous pouvez maintenant envoyer votre message.",
        paymentSuccessClickContinue: "Paiement réussi ! Veuillez cliquer sur 'Envoyer aux invités' pour continuer.",
        paymentSuccessGeneric: "Paiement réussi !",
        paymentProcessingWait: "Veuillez patienter pendant le traitement de votre demande...",
        paymentSystemUnavailable: "Système de paiement indisponible. Veuillez actualiser et réessayer.",
        paymentCompletedReady: "Paiement effectué ! Votre message est prêt à être envoyé.",
        paymentSuccessEmoji: "🎉 Paiement réussi ! Vous pouvez maintenant envoyer votre message.",
        cannotSaveDraftNoEvent: "Impossible d'enregistrer le brouillon : aucun événement sélectionné",
        pleaseLoginToSaveDrafts: "Veuillez vous connecter pour enregistrer les brouillons",
        failedToSaveDraft: "Échec de l'enregistrement. Veuillez réessayer.",
        campaignSentSuccess: "🎉 Message envoyé ! {count} crédits utilisés.",
        insufficientCredits: "Crédits insuffisants. Veuillez acheter plus de crédits pour envoyer votre message.",
        errorProcessingCampaign: "Erreur de traitement. Veuillez réessayer.",
        campaignSubmitted: "Message soumis ! Les messages seront envoyés automatiquement.",
        campaignScheduledFor: "Message programmé ! Les messages seront envoyés le {date}.",
        failedToSchedule: "Échec de la programmation. Veuillez contacter le support.",
        verifyEmailBeforeSending: "Confirmez votre e-mail avant d'envoyer — saisissez le code dans l'onglet Partager de l'éditeur du formulaire, puis envoyez. Votre lien fonctionne déjà pour vos invités. Rien n'a été envoyé ni facturé.",
        translationComplete: "Traduction terminée !",
        translationFailed: "La traduction a échoué. Veuillez réessayer.",
        translationFailedManual: "La traduction a échoué. Veuillez saisir la traduction manuellement.",
        messageTranslatedTo: "Message traduit en {language} !",
        translationFailedRetry: "La traduction a échoué. Réessayez ou saisissez le message manuellement.",
        pleaseWriteMessageFirst: "Veuillez d'abord écrire un message",
        loadFromContacts: "Mes Contacts",
        noSavedContacts: "Aucun contact enregistré pour l'instant. Les contacts auxquels vous envoyez des messages dans une campagne sont automatiquement enregistrés dans votre carnet d'adresses.",
        addressBook: "Carnet d'adresses",
        addContact: "Ajouter un contact",
        deleteContactConfirm: "Supprimer ce contact de votre carnet d'adresses ?",
        edit: "Modifier",
        delete: "Supprimer",
        save: "Enregistrer",
        contactNeedsInfo: "Un contact doit avoir un nom et un e-mail ou un téléphone.",
        importFromPhone: "Importer du téléphone",
        importFromPhoneCancelled: "Aucun contact sélectionné.",
        importFromPhoneFailed: "Échec de l'import des contacts : ",
        importFromGoogle: "Importer depuis Google Contacts",
        noGoogleContactsFound: "Aucun contact trouvé dans votre compte Google.",
        googleContactsFailed: "Échec du chargement des contacts Google : ",
        importFromResponses: "Utiliser ma liste d'invités",
        importFromResponsesTitle: "Importer depuis votre liste d'invités",
        importFromResponsesSubtitle: "Toute la liste d'invités de cet événement : ceux qui ont répondu et ceux que vous avez ajoutés et qui n'ont pas encore répondu. Seuls ceux qui ont un téléphone ou un e-mail peuvent être contactés.",
        noRespondersFound: "Votre liste d'invités est vide : il n'y a personne à importer.",
        noReachableResponders: "Personne sur votre liste d'invités n'a de téléphone ni d'e-mail : il n'y a personne à contacter ici.",
        respondersFailed: "Impossible de charger votre liste d'invités : ",
        respondersUnreachableNote: "{count} autre(s) personne(s) de votre liste n'ont ni téléphone ni e-mail et ne peuvent pas être contactées.",
        respondersAlreadyAdded: "Déjà dans votre liste",
        rsvpStatusColumn: "Réponse",
        rsvpFilterAll: "Tout le monde",
        rsvpFilterYes: "Présents",
        rsvpFilterMaybe: "Peut-être",
        rsvpFilterNo: "Absents",
        rsvpFilterWaitlisted: "Liste d'attente",
        rsvpFilterPending: "Sans réponse",
        rsvpStatusYes: "Oui",
        rsvpStatusMaybe: "Peut-être",
        rsvpStatusNo: "Non",
        rsvpStatusWaitlisted: "Liste d'attente",
        rsvpStatusPending: "Sans réponse",
        addMoreContacts: "Ajouter d'autres contacts",
        exportCsv: "Exporter CSV",
        status: "Statut",
        tags: "Étiquettes",
        allTags: "Toutes les étiquettes",
        replaceFile: "Remplacer le fichier",
        maxGuestsCol: "Invités max",
        maxGuestsColHint: "Nombre maximum d'invités que cette invitation peut amener (laissez vide pour utiliser la limite par défaut du formulaire)",
        // The guest-list columns (task #935)
        guestNamesCol: "Nom(s) des invités",
        guestNamesColHint: "Comment ajouter les noms des invités\n• Séparez les noms par un point-virgule (;). Les virgules fonctionnent aussi.\n• Ajoutez (enfant) après le nom d’un enfant, par ex. Léo Martin (enfant).\n• Exemple : Sophie Martin; Marc Martin; Léo Martin (enfant)\n• Le téléphone et l’e-mail de la ligne sont ceux de la première personne de la liste.",
        guestNamesPh: "Sarah Martin; Michel Martin",
        groupNameCol: "Nom du groupe",
        groupNameColHint: "À qui l’invitation est adressée, par ex. Famille Martin. Il figure sur l’enveloppe et dans l’accueil du formulaire ; les messages saluent les noms des invités (« Bonjour Sophie & Marc »).\nLaissez vide pour un invité seul. Si vous ne remplissez que le nom du groupe, les invités retrouvent leur invitation grâce à lui et saisissent leurs noms ; avec des noms d’invités, chacun la retrouve par son propre nom.",
        groupNamePh: "Famille Martin",
        contactPreviewTitle: "Aperçu de cette invitation",
        contactPreviewEnvelope: "Adressée à",
        contactPreviewGreetingLine: "Bonjour {name}",
        contactPreviewLookup: "Saisir l’un de ces noms retrouve cette invitation :",
        contactPreviewNoLookup: "Ajoutez un nom de famille ou un nom de groupe pour que cet invité retrouve l’invitation par son nom.",
        contactPreviewAsksNames: "Pas encore de noms : la personne qui la trouve indiquera les noms de son groupe.",
        diffSurnamesTip: "Astuce : ajoutez un numéro de téléphone, un e-mail ou le nom complet de chaque membre du groupe pour que chacun puisse facilement retrouver sa réponse.",
        sameNameWarning: "Attention : plusieurs invités ou groupes portent le même nom. Ajoutez une adresse e-mail ou un numéro de téléphone pour chacun afin qu’ils puissent confirmer leur identité lors de la recherche.",
        lastFirstFlag: "Une seule personne, nom de famille en premier ? Séparez les personnes différentes par « ; ».",
        prefillNameLabel: "Pré-remplir le nom de chaque invité sur le formulaire",
        prefillNameDesc: "Chaque lien personnel s'ouvre avec le nom du contact déjà inscrit dans la case du nom (et sur l'enveloppe, si cette option est activée). Désactivez-le si votre liste contient des surnoms ou des numéros partagés : les invités saisissent leur nom ; les limites d'invités restent appliquées.",
        contactsSelected: "contact(s) sélectionné(s)",
        addSelected: "Ajouter la sélection",
        selectAll: "Tout Sélectionner",
        importedContactsSummary: "{added} contact(s) importé(s). {skipped} ignoré(s) comme doublon(s).",
        noOrgFound: "Aucune organisation trouvée. Configurez votre organisation d'abord.",
        noOrgContacts: "Aucun contact trouvé dans votre organisation. Ajoutez des contacts d'abord.",
        failedToLoadContacts: "Échec du chargement des contacts : ",
        selectAtLeastOneContact: "Veuillez sélectionner au moins un contact.",
        contactsClearedMessage: "Contacts effacés. Vous pouvez maintenant télécharger une nouvelle liste.",
        unsavedContactsWarning: "Vous avez des contacts non enregistrés. Appuyez sur Annuler pour revenir et enregistrer, ou OK pour abandonner.",
        unsupportedFileType: "Type de fichier non pris en charge. Veuillez télécharger un fichier CSV (.csv) ou vCard (.vcf).",
        fileAlreadyUploaded: "Le fichier \"{filename}\" a déjà été téléchargé.",
        fileReplaced: "Les {replaced} contact(s) de \"{filename}\" ont été remplacés par les {count} du fichier que vous venez d'importer.",
        fileMergedSummary: "{added} contact(s) ajouté(s) depuis \"{filename}\" ; {updated} déjà dans votre liste mis à jour avec les données du fichier.",
        failedToProcessFile: "Échec du traitement du fichier. Vérifiez le format et réessayez.",
        noContactsInFile: "Nous avons lu « {filename} » mais n'y avons trouvé aucun contact.\n\nColonnes trouvées : {headers}\n\nChaque contact doit avoir une adresse e-mail ou un numéro de téléphone, sous un intitulé que nous reconnaissons — par exemple « name », « email », « phone ». Renommez les intitulés dans votre tableur puis réessayez.",
        encodingDamageWarning: "« {filename} » semble avoir perdu ses caractères non anglais : les noms s'affichent sous la forme « ??? » ou en texte illisible.\n\nCela se produit généralement lorsque Excel sur un Mac enregistre un fichier .csv standard. Le texte d'origine ne figure déjà plus dans le fichier ; l'importer créerait donc des contacts aux noms illisibles.\n\nPour corriger : dans Excel, choisissez Fichier → Enregistrer sous → « CSV UTF-8 (délimité par des virgules) », puis réimportez. Google Sheets et Numbers exportent automatiquement des fichiers corrects.\n\nImporter quand même ?",
        processingFile: "Traitement de {filename}...",
        missingNamesWarning: "{count} contact(s) n'ont pas de nom — ils apparaîtront comme « Inconnu ». Ajoutez-les dans la liste ci-dessous.",
        // Household invitations (task #908)
        householdCouplesSuggest: "{count} invitation(s) nomment plusieurs personnes, par ex. « {example} ». Compter toutes les personnes nommées, avec leurs noms déjà remplis dans le formulaire ?",
        householdCouplesYes: "Oui, les compter",
        householdNoThanks: "Non merci",
        householdFamiliesNote: "{count} invitation(s) sont adressées à une famille, par ex. « {example} ». Indiquez qui vient dans {members} (ou fixez {maxGuests}) pour que le formulaire remplisse leurs noms et les compte correctement.",
        loadingText: "Chargement...",
        verifyingPayment: "Vérification du statut de paiement...",
        pleaseWaitVerify: "Veuillez patienter pendant la confirmation de votre mise à niveau",
        paymentVerified: "Paiement vérifié !",
        paymentProcessing: "Paiement en cours",
        errorVerifyingPayment: "Erreur de vérification du paiement",
        validLabel: "Valide",
        checkLabel: "À vérifier",
        toCheck: "à vérifier",
        phoneCheckChargedNote: "envoyé et facturé tel quel si vous ne le corrigez pas",
        phoneWarnDoubledCc: "l’indicatif du pays apparaît deux fois",
        phoneWarnCc927: "927 n’est pas un indicatif de pays — vouliez-vous dire +972 ?",
        phoneWarnNanpArea: "l’indicatif régional d’un numéro +1 ne peut pas commencer par 0 ou 1",
        phoneWarnNanpNoCc: "s’il s’agit d’un numéro américain ou canadien, il faut +1 : {suggest}",
        phoneWarnLength: "un mobile +{cc} a {want} chiffres après l’indicatif du pays ; celui-ci en a {got}",
        phoneWarnUkPrefix: "un mobile +44 commence par 7",
        phoneWarnIlPrefix: "un mobile +972 commence par 5",
        phoneWarnAssumed: "sans indicatif du pays — lu comme {country} ({number}) ; corrigez-le si ce n’est pas le bon",
        phoneWarnNeedsCountry: "sans indicatif du pays — ajoutez-le au début, par exemple +33",
        phoneWarnInvalid: "ce n’est pas un numéro valide ({country}) — vérifiez les chiffres",
        phoneWarnInvalidAny: "ce n’est pas un numéro de téléphone valide — vérifiez les chiffres",
        phoneWarnLandline: "c’est une ligne fixe ({country}) — elle ne peut recevoir ni WhatsApp ni SMS",
        phoneCountryLabel: "Les numéros sans indicatif du pays sont lus comme",
        phoneCountryHint: "La plupart des numéros de votre liste sont de ce pays : {country}.",
        phoneCountryUse: "Utiliser {country}",
        contactsLoaded: "Contacts chargés",
        countryUnknown: "Inconnu",
        rowLabel: "Ligne",
        deliveryDisclaimer: "La remise n’est jamais garantie à 100 %. Une petite partie des messages peut être retenue par les limites marketing de Meta, les filtres des opérateurs, les dossiers spam ou des coordonnées erronées — c’est normal sur toutes les plateformes de messagerie.",
        tagsCol: "Étiquettes",
        tagsColHint: "Le groupe de cet invité, par ex. famille, réception uniquement. Séparez les étiquettes par des virgules.\nSi une partie de l’événement est réservée à certaines étiquettes (réglage dans l’éditeur, sous Parties de l’événement), le lien personnel de cet invité n’affiche que les parties correspondant à ses étiquettes.",
        campaignNameDupAddInstead: "Cliquez ici pour ajouter directement les contacts à votre message existant",
        campaignNameDupAddInsteadSuffix: "à la place",
        progressChecklistTitle: "Votre progression",
        checkCampaignName: "Nom du message",
        checkAddContacts: "Ajouter des contacts",
        checkCustomizeMessage: "Personnaliser le message",
        checkConfigureFollowUp: "Configurer le suivi",
        checkSendInvitations: "Envoyer les invitations",
        contactsSummaryTitle: "Résumé des contacts",
        totalGuestsAdded: "Total des invités ajoutés",
        contactsImported: "Contacts importés",
        needsAttention: "À vérifier",
        supportedImportMethods: "Modes d’importation",
        manualEntry: "Saisie manuelle",
        headerOptional: "(Facultatif)",
        renameTooltip: "Renommer",
        gateNoRecipients: "Ajoutez au moins un destinataire avant de passer à l’envoi.",
        gateNoMessage: "Rédigez votre message avant de passer à l’envoi.",
        gateGoToStep: "Aller à l’étape {n}",
        sendStalled: "La connexion à nos serveurs s’est interrompue avant l’enregistrement de votre message — rien n’a été envoyé et aucun crédit n’a été utilisé. Rechargez la page, rouvrez le message et appuyez de nouveau sur Envoyer.",
        loadingSites: "Chargement de vos sites de mariage…",
        noWeddingSites: "Aucun site de mariage trouvé.",
        createWeddingSite: "En créer un",
        usingSite: "Site utilisé :",
        chooseSite: "Choisissez un site de mariage…",
        siteNotPublished: "à publier pour l’utiliser",
        noPublishedSite: "Aucun de vos sites de mariage n’est encore publié — publiez-en un pour que les invités puissent répondre.",
        rsvpEnabledHint: "Vérifiez que la page RSVP de votre site est activée pour que les invités puissent répondre.",
        loadingFollowUp: "Chargement du message de suivi...",
        loadingDraft: "Chargement du brouillon...",
        creditsAlreadyEnough: "Vous avez déjà assez de crédits pour ce message — vérifiez-le et appuyez sur Envoyer.",
        remindersSkippedBeforeSend: "{count} rappel(s) non programmé(s) — leur heure tombe avant l’envoi de ce message.",
        invalidLabel: "Invalide",
        verifyCountryCode: "⚠ Vérifiez l'indicatif pays",
        enterGuestName: "Entrez le nom de l'invité",
        emailPlaceholder: "nom@exemple.com",
        phonePlaceholder: "+33612345678",
        validContacts: "Contacts valides",
        scheduledTimePast: "L'heure programmée ne peut pas être dans le passé",
        recipientsLabel: "Destinataires",
        noNameLabel: "(sans nom)",
        removeRecipient: "Retirer",
        removeThisContact: "Retirer ce contact",
        allRecipientsRemoved: "Tous les destinataires ont été retirés. Ajoutez-en pour pouvoir envoyer.",
        sendNoFormSelected: "Aucun formulaire n'est sélectionné pour ce message. Ouvrez d'abord un formulaire enregistré, puis réessayez l'envoi.",
        sendFormNotSaved: "Votre formulaire n'a pas fini de s'enregistrer. Rouvrez-le dans l'éditeur, enregistrez-le, puis réessayez l'envoi.",
        draftSavedFindOnDashboard: "Brouillon enregistré. Vous le trouverez sous Messages, dans votre tableau de bord.",
        processingButton: "Traitement...",
        personalize: "Personnaliser :",
        demoLabel: "démo",
        searchContactsPlaceholder: "Rechercher par nom, email ou téléphone...",
        loading: "Chargement...",

        // New wizard keys
        fullNamePlus: "+ Nom Complet",
        firstNamePlus: "+ Prénom",
        emailPlus: "+ Email",
        tableNumberPlus: "+ Numéro de Table",
        tableTagDisabledHint: "Configurez le plan de table intégré pour personnaliser avec le numéro de table de chaque invité.",
        tableExampleInput: "Votre table est la {{table_number}}",
        tableSplitNoticeOne: "1 groupe est réparti sur plusieurs tables sans le nom de chaque invité : sa ligne de table ressemblera à « Dana 2, Dana 3 ». Ajoutez le nom de chaque invité dans la liste des invités pour que ce soit clair.",
        tableSplitNoticeMany: "{count} groupes sont répartis sur plusieurs tables sans le nom de chaque invité : leur ligne de table ressemblera à « Dana 2, Dana 3 ». Ajoutez le nom de chaque invité dans la liste des invités pour que ce soit clair.",
        clickToInsert: "Cliquez pour insérer — chaque invité reçoit sa version personnalisée.",
        seeExample: "Voir exemple",
        hideExample: "Masquer exemple",
        youWrite: "Vous écrivez :",
        exampleInput: "Bonjour {{first_name}}, vous êtes invité à notre événement !",
        eachGuestGets: "Chaque invité reçoit :",
        sendTestEmailToMe: "M'envoyer d'abord un e-mail de test",
        testEmailSending: "Envoi de l'e-mail de test…",
        testEmailSent: "E-mail de test envoyé à {email}",
        testEmailFailed: "Impossible d'envoyer l'e-mail de test",
        sendTestTitle: "Envoyez-vous un test",
        sendTestSubtitle: "Recevez une vraie copie sur votre téléphone et votre boîte mail, exactement comme vos invités la verront.",
        sendTestBtn: "Envoyer un test",
        sendTestCostNote: "Votre premier test sur ce message est gratuit. Ensuite, chaque test par SMS ou WhatsApp coûte 1 crédit — les tests par e-mail restent toujours gratuits.",
        sendTestCostAfterFree: "Votre test gratuit sur ce message a été utilisé. Chaque test supplémentaire par SMS ou WhatsApp coûte 1 crédit — les tests par e-mail restent gratuits.",
        sendTestPhoneLabel: "Numéro de mobile pour le test",
        sendTestPhoneHint: "Votre compte n'a pas de numéro de mobile : saisissez-en un pour recevoir le test. Nous le retiendrons.",
        sendTestPhoneInvalid: "Cela ne ressemble pas à un numéro de mobile. Utilisez le format international, par exemple +14155550123.",
        sendTestSending: "Envoi de votre test…",
        sendTestDone: "Test envoyé",
        sendTestEmailCopyOnly: "L'e-mail est une copie pour vous — vos invités ne recevront pas d'e-mail.",
        sendTestFailed: "Impossible d'envoyer le test",
        sendTestCreditReturned: "Le crédit de ce test a été recrédité sur votre solde.",
        sendTestEmptyMessage: "Écrivez d’abord votre message — il n’y a rien à tester.",
        sendTestRoutedToWhatsApp: "Numéro non américain : ce test passe donc par WhatsApp.",
        // A test parked waiting for Meta, and every way that wait can end (task #604).
        sendTestQueued: "Votre test est en attente. WhatsApp est encore en train d’approuver votre message — le test partira tout seul dès l’approbation, vous n’avez rien d’autre à faire ici.",
        sendTestQueuedSent: "Approuvé — votre test vient d’être envoyé sur votre WhatsApp.",
        sendTestQueuedFailed: "WhatsApp a approuvé votre message, mais le test n’a pas pu être envoyé. Appuyez sur Envoyer un test pour réessayer.",
        sendTestQueuedNoCredits: "WhatsApp a approuvé votre message, mais le test en attente nécessitait un crédit et aucun n’était disponible. Rechargez puis appuyez de nouveau sur Envoyer un test.",
        sendTestQueuedExpired: "Votre test en attente a expiré avant que WhatsApp n’approuve le message. Appuyez de nouveau sur Envoyer un test pour en envoyer un maintenant.",
        // What the status webhook later says about an accepted WhatsApp test.
        sendTestDelivered: "Distribué sur votre WhatsApp ✓",
        sendTestNotDelivered: "Le test WhatsApp n’a pas été distribué",
        sendTestMetaLimit: "WhatsApp n’a pas distribué ce test : Meta limite le nombre de messages marketing qu’un même numéro peut recevoir, et des tests répétés peuvent atteindre cette limite sur votre propre numéro. Votre campagne et vos invités ne sont PAS concernés — vous pouvez envoyer en toute sérénité. Pour refaire un test tout de suite, envoyez n’importe quel message (même « bonjour ») au numéro WhatsApp d’où venait votre test précédent, puis réessayez — la limite ne s’applique pas dans une conversation ouverte. Sinon, patientez quelques heures.",
        includeRsvpLink: "Inclure le lien de confirmation dans le message",
        rsvpLinkDisabledDesc: "Si désactivé, le message est envoyé sans lien vers le formulaire de confirmation.",
        includeQrCode: "Inclure le code QR d'enregistrement",
        qrCodeDesc: "Les invités ayant confirmé recevront leur code QR personnel.",
        qrCodeWhatsappNote: "Sur WhatsApp, le code QR remplacera l'image du message.",
        finalCampaignSummary: "Résumé Final du Message",
        messagesToSend: "Messages à Envoyer",
        creditsUsed: "Crédits Utilisés",
        clickingScheduleNote: "En cliquant sur \"Programmer et Envoyer\", vos messages seront mis en file d'attente.",
        scheduleAndSend: "Programmer et Envoyer",
        canStillGoBack: "Vous pouvez encore revenir et apporter des modifications avant l'envoi.",
        campaignSentSuccessfully: "Message envoyé avec succès !",
        messagesBeingDelivered: "Vos {count} messages sont en cours de livraison.",
        windowWillClose: "Cette fenêtre se fermera automatiquement...",
        closeButton: "Fermer",
        smsConsentAgree: "J'accepte les",
        andText: "et",
        buyMessageCredits: "Acheter des Crédits",
        campaignRequires: "Le message nécessite :",
        yourBalanceLabel: "Votre solde :",
        needLabel: "Besoin :",
        selectPackage: "Sélectionnez un forfait :",
        bestValue: "Meilleure Offre",
        calcHelper: "Combien de crédits me faut-il ?",
        freeShareBalance: "Vous avez {n} crédits de messages (chaque compte commence avec 25 offerts), et votre premier message test est gratuit.",
        freeShareLead: "Vous préférez l’envoyer depuis votre téléphone ou votre e-mail ? Aucun crédit utilisé :",
        freeShareCopy: "Copier le lien",
        freeSharePersonal: "Liens personnels",
        freeShareCopied: "Lien copié",
        calcGuests: "invités",
        calcMsgs: "messages chacun",
        calcCadence: "La plupart des hôtes envoient 3 messages par invité : invitation, rappel, rappel du jour J. Les rappels ne vont généralement qu'aux non-répondants — l'usage réel est souvent plus bas.",
        creditsAmount: "{count} crédits",
        creditsMoreAmount: "{count} crédits de plus",
        creditsUnit: "crédits",
        packEnoughForSend: "Suffisant pour ce message",
        packNeedMore: "Il en manque {count}",
        creditsNeverExpireNote: "Les crédits n'expirent jamais • Utilisables sur tous vos formulaires",
        haveEnoughCredits: "Vous avez assez de crédits !",
        creditsAvailableNeeded: "{balance} crédits disponibles ({needed} nécessaires)",
        selectCreditPackage: "Veuillez choisir un pack de crédits",
        purchaseStartFailed: "Impossible de lancer l'achat. Veuillez réessayer.",
        previewNotInteractive: "Aperçu — non interactif",
        emailTab: "Email",
        whatsappTab: "WhatsApp",
        smsTab: "SMS",
        translating: "Traduction...",
        otherLanguage: "Autre Langue",
        campaignSubmittedSuccessfully: "Message envoyé avec succès !",
        submittingCampaign: "Envoi du message...",
        submissionFailed: "Échec de l'envoi",
        submitting: "Envoi...",
        errorDetails: "Détails de l'erreur :",
        missingEmailAndPhone: "Email et téléphone manquants",
        invalidEmailFormat: "Format d'email invalide",
        invalidPhoneFormat: "Format de téléphone invalide",
        paymentSuccessful: "Paiement réussi !",
        unknownError: "Erreur inconnue",
        removeImage: "Supprimer l'image",
        pendingTranslation: "Traduction en attente",
        removeLanguage: "Supprimer la langue",
        notSpecified: "Non spécifié",
    }
};

// Register with dashboard language system if available
if (window.DashboardLanguageSystem) {
    window.DashboardLanguageSystem.registerLanguageContent('fr', window.FrenchDashboardContent);
}
